import { api } from "@/lib/api";

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

// Ensures this device is subscribed for Web Push (called after the user grants notification permission).
export async function ensurePushSubscription() {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  try {
    const { data } = await api.get("/push/vapid-public-key");
    if (!data?.enabled) return false;
    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.key) });
    await api.post("/push/subscribe", sub.toJSON());
    return true;
  } catch (e) {
    console.warn("push subscribe failed", e);
    return false;
  }
}

export async function removePushSubscription() {
  if (!pushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) { await api.delete("/push/subscribe", { data: sub.toJSON() }).catch(() => {}); await sub.unsubscribe(); }
  } catch (_) {}
}
